import { render, staticRenderFns } from "./GlobalDispatchFooter.vue?vue&type=template&id=b9455902&scoped=true&name=global-dispatch-footer&"
import script from "./GlobalDispatchFooter.vue?vue&type=script&lang=js&"
export * from "./GlobalDispatchFooter.vue?vue&type=script&lang=js&"
import style0 from "./GlobalDispatchFooter.vue?vue&type=style&index=0&id=b9455902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9455902",
  null
  
)

export default component.exports